export class SearchPackage
{
    id : number;
    name : string;
    reusable : boolean;
    clientLocationId : number;
    isDefaultPackage : boolean;
    isPMPackage : boolean;
    searches : Array<SearchRecord>;
    cost:number;
    clientId :any;
    notes: string;
    selected : boolean;
    isActive : boolean;
    createdOn : Date;
    lastModified : Date;
    lastModifiedBy : string;
    clientIds :number[];
}

export class SearchRecord
{
    id : number;
    name : string;
    vendor : SearchVendors;
    cost : number;
    vendorName : string;
    searchType : VendorResponseTypes;
    searchMeta : any;
    includedInBundledPrice : boolean;
    searchesIncludedInBundledPrice : number;
    
}


export class CustomResponseData {
    id : number;
    searchName : string;
    customSearchDescription : string;
    includeWithReport : boolean;
    recordFound : boolean;
    customSearchStatus : SearchStatus;
    searchStatusDisplay : string;
    orderId : number;
    applicantId : number;
    receivedDate : Date;
    responseType : VendorResponseTypes;
    inviteToken : string;
    searchQualifier : string;
    editing : boolean;
    isImage : boolean;
}


export enum SearchStatus {
    NotRun = 1, //- in the package, but wasn’t ever pulled from vendor
    Processing = 2, //- waiting to receive information back from the vendor
    Complete = 3,  //- search is done
    Error = 4, //- received an error from the vendor
    Voided = 5, // - search was canceled by a CRA user
    InDispute = 6 // - applicant has called in to dispute an item in the search. Status can only be initiated manually by a CRA user
}

export enum CriminalSearchTypes
{
    County = 0,
    State = 1,
    Federal = 2,
    // international = 3,
    // singlestate = 4,
    National = 5,
    // national_alias = 6,
    // security = 7
}

export enum VendorResponseTypes
{
    Credit = 1,
    Criminal = 2,
    Eviction = 3,
    Person = 4,
    Employment = 5,
    FollowUp = 6,
    TaxLien = 7,
    //this is set to 9 because RentToIncome is mapped to 8 on the backend
    CustomSearch = 9,
    Error = 10,
    ResidenceVerification = 11,
    IdentityVerification = 12
}

export enum SearchVendors
{
    TazWorks = 0,
    Tracers = 1,
    Equifax = 8,
    TU = 11
}